import React, { useContext } from 'react'
import { Title, SubHeaderDesktop, Container, SubTitle } from '@provi/provi-components'
import { TemplateContext } from '~/components/template/context'
import { FormFormik } from './form'
import { useEmail } from './hooks'

export const Email = () => {
  const {
    handleModal,
    isMobile,
    setCurrent,
    setIsLoading,
    isLoading,
    checkToken,
    guarantorInfo,
    setGuarantorInfo,
    goToPage
  } = useContext(TemplateContext)

  const [data] = useEmail(setIsLoading, setCurrent, checkToken, guarantorInfo)

  return (
    <Container>
      {!isLoading && data && (
        <>
          {isMobile ? (
            <Title cy="title" text="Qual o seu email?" />
          ) : (
            <SubHeaderDesktop cy="title" title="Qual o seu email?" handleModal={handleModal} />
          )}
          <SubTitle
            text={`Precisa ser um email pessoal d${data.firstName ? 'e' : 'o'} ${
              data.firstName ? data.firstName : 'avalista'
            }. E lembre-se: você precisará verificar esse email!`}
          />

          <FormFormik data={data} setIsLoading={setIsLoading} setGuarantorInfo={setGuarantorInfo} goToPage={goToPage} />
        </>
      )}
    </Container>
  )
}
